var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-tooltip.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/chemistry/renderable.js";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import { html, render } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import { fromEvent, takeUntil } from "rxjs";
import tippy, { followCursor } from "tippy.js";
import "./tippy-styles.css";
var XTooltip = class extends ChemistryLitElement {
  constructor() {
    super();
    this.options = {};
    this.slotElement = document.createElement("slot");
    this.style.display = "none";
  }
  set content(content) {
    if (this._content === content)
      return;
    this._content = content;
    this.reinit();
  }
  get content() {
    return this._content;
  }
  _defaultOptions() {
    return {
      content: this.content,
      placement: "top",
      interactive: false,
      trigger: "mouseenter focus",
      triggerTarget: this.parentElement,
      appendTo: window.document.body,
      animation: "fade",
      arrow: false,
      maxWidth: "none",
      touch: true,
      hideOnClick: true,
      theme: "custom",
      duration: [200, 0],
      delay: [0, 0],
      followCursor: false,
      // setting this true can cause performance issues
      plugins: [followCursor],
      zIndex: 1003
    };
  }
  connectedCallback() {
    super.connectedCallback();
    const shadowRoot = this.shadowRoot;
    shadowRoot?.appendChild(this.slotElement);
    this.renderRoot = document.createElement("div");
    this.renderRoot.style.display = "contents";
    this.content = this.renderRoot;
    fromEvent(this.slotElement, "slotchange").pipe(takeUntil(this.disconnected)).subscribe((e) => this._updateContents());
    this.reinit();
  }
  firstUpdated() {
    this._updateContents();
  }
  updated(changedProps) {
    super.updated(changedProps);
    this._updateContents();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.tippy?.destroy();
  }
  reinit() {
    this.tippy?.destroy();
    this.tippy = tippy(
      // @ts-ignore tippy always takes the wrong overload
      this.parentElement,
      {
        ...this._defaultOptions(),
        appendTo: this._lookForDialogElementInParents(),
        ...this.options,
        onShow: () => this.dispatchEvent(new CustomEvent("open")),
        onHide: () => this.dispatchEvent(new CustomEvent("close"))
      }
    );
  }
  render() {
    return xComponents(html`
      <x-basic-card
        raised
        padding="sm"
        ${css({ background: this.colors.white })}
        ${ref((content) => this._contentFlex = content)}
      >
      </x-basic-card>
    `);
  }
  _updateContents() {
    if (this.text) {
      if (this._contentFlex)
        render(this.text, this._contentFlex);
    } else {
      const contentElements = Array.from(this.slotElement.assignedNodes());
      if (!contentElements || !contentElements.length)
        return;
      if (this._contentFlex)
        contentElements.forEach((content) => this._contentFlex.appendChild(content));
    }
  }
  /**
   * TODO use native dialog element for our tooltips
   * ! This is a dirty hack to determine if this dropdown is inside a native dialog element
   * -> If so, we attach tippy to said dialog element
   */
  _lookForDialogElementInParents() {
    let curr = this;
    while (
      // @ts-expect-error host exists on rootNode in this context
      (curr = curr.parentElement || curr.getRootNode()?.host) && !(curr instanceof HTMLDialogElement) && !(curr instanceof XNativeDialog)
    ) {
    }
    if (curr instanceof HTMLDialogElement || curr instanceof XNativeDialog)
      return curr;
    return window.document.body;
  }
};
__decorateClass([
  property()
], XTooltip.prototype, "text", 2);
XTooltip = __decorateClass([
  customElement("x-tooltip")
], XTooltip);
export {
  XTooltip
};
